module.exports = __webpack_public_path__ + "static/media/calendar.26ab6bb6.svg";